import React from 'react';

import { Typography } from '@mui/material';

import { StyledChip } from '../../common_components/styled';

export const Investors = ({ investors, investments }) => {
  return (
    <>
      <Typography variant="h6" gutterBottom component="div">
        {`Investors / Backers / Partners / Advisors`}
      </Typography>
      {investors.map((data, index) => (
        <StyledChip
          label={data.invstor_name}
          fontColor="black"
          bgColor="#f3f4f6"
          sx={{ m: 1 }}
          key={index}
          size="small"
        />
      ))}

      {investments?.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom component="div">
            {`Investments:`}
          </Typography>
          {investments.map((data, index) => (
            <Typography variant="body2" gutterBottom component="div" key={index}>
              {data.inv_details}
            </Typography>
          ))}
        </>
      )}
    </>
  );
};
